var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#3D714E;stroke:#3D714E;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M381,248.6L146.4,3.3c-4.1-4.2-10.8-4.4-15.1-0.3C127,7,126.9,13.8,131,18l227.6,238L131,494\n\t\t\tc-4.1,4.3-3.9,11,0.3,15.1c2.1,2,4.7,3,7.4,3c2.8,0,5.6-1.1,7.7-3.3L381,263.4C385,259.2,385,252.7,381,248.6z"})))]);
}

Right.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = Right;

Right.default = Right;
